import { Paper } from "@material-ui/core";
import styled from "styled-components";

export const Container = styled(Paper)`
  max-width: 700px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 28px;
`;
